import { render, staticRenderFns } from "./budget-variables.vue?vue&type=template&id=564d75fc&"
import script from "./budget-variables.vue?vue&type=script&lang=js&"
export * from "./budget-variables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports